const reg = new RegExp('http[s]?://(?:(?!http[s]?://)[a-zA-Z]|[0-9]|[$\-_@.&+/]|[!*\(\),]|(?:%[0-9a-fA-F][0-9a-fA-F]))+')

export default function(str){
    const pattern = reg.exec(str);
    if(pattern){
        return pattern[0]
    }
    return null
}